import { render, staticRenderFns } from "./CommonBox.vue?vue&type=template&id=264cae68"
import script from "./CommonBox.vue?vue&type=script&lang=js"
export * from "./CommonBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports